import { UAParser } from 'ua-parser-js'; // Determine whether the web page is currently open on a real phone

export var judgeIsMobilePhone = function judgeIsMobilePhone() {
  var deviceType = new UAParser(navigator.userAgent).getDevice();

  if (deviceType.type === 'mobile') {
    return true;
  }

  return false;
};
export var isSafari = function isSafari() {
  var _browser$name;

  var browser = new UAParser().getBrowser();
  return (browser === null || browser === void 0 ? void 0 : (_browser$name = browser.name) === null || _browser$name === void 0 ? void 0 : _browser$name.toLowerCase()) === 'safari';
};